import { Stack } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import { useParams } from 'react-router-dom'

import { DisplayTable } from '@/components/displays/DisplayTable'
import useT from '@/i18n/useT'

const PlanogramList: React.FC = () => {
  const { id: storeId } = useParams()
  const { t } = useT()

  if (!storeId) return null

  return (
    <>
      <Helmet title={t('helmet.planograms')} />
      <Stack py={3}>
        <DisplayTable storeId={storeId} />
      </Stack>
    </>
  )
}

export default PlanogramList
